import { SurveyV2 } from '@act/shared/data-transfer-objects';
import { ControlledSelect } from '@act/storybook';
import { Control } from 'react-hook-form';
import type { SurveyFormData } from './types';

export interface SelectInputProps {
  control: Control<SurveyFormData>;
  name: string;
  options: SurveyV2.OptionDto[];
  isMultiple: boolean;
  isRequired: boolean;
  togglePrompt: (prompt: SurveyV2.PromptDto) => void;
}

const SelectInput = ({
  control,
  name,
  options,
  isMultiple,
  isRequired,
  togglePrompt,
}: SelectInputProps) => {
  if (isMultiple) {
    throw new Error('Multiple select is not supported');
  }

  const formattedOptions = options.map(options => {
    return {
      label: options.text,
      value: `${options.id}`,
      callback: () => togglePrompt(options.prompt),
    };
  });
  // TODO: Enable multi-select
  return (
    <ControlledSelect<SurveyFormData, typeof name>
      name={name}
      label={''}
      control={control}
      options={formattedOptions}
      required={isRequired}
      fullWidth
    />
  );
};

export default SelectInput;
